import { Building2, Loader2, Users } from 'lucide-react'
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
  PageHeader,
} from '@atrvd/saas-ui'
import { useOrganizations } from '@/hooks/useOrganizationInvitations'
import { formatDate } from '@dcp/shared/utils/formatters'

/**
 * Admin page for viewing and managing organizations
 */
export function OrganizationsPage() {
  const { data: organizations, isLoading, error } = useOrganizations()

  return (
    <div className="space-y-6">
      <PageHeader
        title="Organizations"
        description="View and manage tenant organizations"
      />

      {/* Stats Card */}
      <div className="grid gap-4 md:grid-cols-3">
        <Card>
          <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
            <CardTitle className="text-sm font-medium">Total Organizations</CardTitle>
            <Building2 className="h-4 w-4 text-muted-foreground" />
          </CardHeader>
          <CardContent>
            <div className="text-2xl font-bold">{organizations?.length ?? 0}</div>
          </CardContent>
        </Card>
      </div>

      {/* Organizations Table */}
      <Card>
        <CardHeader>
          <CardTitle className="flex items-center gap-2">
            <Users className="h-5 w-5" />
            All Organizations
          </CardTitle>
        </CardHeader>
        <CardContent>
          {isLoading ? (
            <div className="flex items-center justify-center py-8">
              <Loader2 className="h-8 w-8 animate-spin text-gray-400" />
            </div>
          ) : error ? (
            <div className="py-8 text-center text-red-600">
              Failed to load organizations: {error.message}
            </div>
          ) : organizations && organizations.length > 0 ? (
            <Table>
              <TableHeader>
                <TableRow>
                  <TableHead>Organization Name</TableHead>
                  <TableHead>Admin Email</TableHead>
                  <TableHead>Admin Name</TableHead>
                  <TableHead>Created</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody>
                {organizations.map((org) => (
                  <TableRow key={org.id}>
                    <TableCell className="font-medium">{org.name}</TableCell>
                    <TableCell>{org.admin_email || '—'}</TableCell>
                    <TableCell>{org.admin_name || '—'}</TableCell>
                    <TableCell>{formatDate(org.created_at)}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <div className="py-8 text-center text-gray-500">
              No organizations found. Create one via the Invitations page.
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  )
}